import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import {ViewerInfo} from '../../graphql/generated/types';

/**
 * 뷰어 정보 조회
 *
 * Origin: pageNicolasApi.getViewerInfo
 * API: GET /api/v1/viewer/data
 */
export async function getViewerInfo(
  {seriesId, productId}: {seriesId: number; productId: number},
  options?: FetcherOptions
): Promise<
  ApiResultVo & ViewerInfo /* 이 녀석은 특이하게 bff 단에서 변환합니다 */
> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/viewer/data',
    {
      method: 'GET',
      params: {
        series_id: seriesId,
        product_id: productId,
      },
    },
    options
  );
  return response.data;
}
